var _rect, _g, _rect2, _rect3, _rect4, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 55,
    viewBox: "0 0 86 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 44 Copy 6"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.55,
    y: 1.3,
    width: 82.808,
    height: 52.856,
    rx: 3.388,
    fill: "white",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle Copy 26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_12912_44176",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.07031,
    y: 5.75195,
    width: 10.7116,
    height: 7.504,
    rx: 1.0752
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.07031,
    y: 5.75195,
    width: 10.7116,
    height: 7.504,
    rx: 1.0752,
    fill: "white",
    stroke: "#106C3A",
    strokeWidth: 2.8,
    mask: "url(#path-2-inside-1_12912_44176)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 27",
    x: 20.6238,
    y: 6.98809,
    width: 58.0493,
    height: 5.032,
    rx: 2.516,
    fill: "white",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 7.44063,
    y: 17.3801,
    width: 22.8232,
    height: 25.52,
    rx: 1.7752,
    fill: "white",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12912_44176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 25,
    height: 28
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 7.44063,
    y: 17.3801,
    width: 22.8232,
    height: 25.52,
    rx: 1.7752,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12912_44176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Male_icon Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9807 29.162C24.9807 29.9049 25.5829 30.5071 26.3258 30.5071H26.7914C26.7914 32.7088 24.9674 34.4936 22.7173 34.4936H15.4745C13.2244 34.4936 11.4004 32.7088 11.4004 30.5071H11.866C12.6089 30.5071 13.2111 29.9049 13.2111 29.162V25.6347C13.2111 22.4545 15.8458 19.8765 19.0959 19.8765C22.346 19.8765 24.9807 22.4545 24.9807 25.6347V29.162Z",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.031 34.2468L20.9057 32.7217H17.2843L17.159 34.2468C17.0805 35.2032 16.4813 36.0439 15.5912 36.4464L12.5804 37.8081L12.573 37.8112C12.4881 37.8482 10.4941 38.7444 10.4941 41.2098V42.4665V42.5108H10.4988C10.6501 43.2241 14.4408 43.7953 19.095 43.7953C23.7492 43.7953 27.54 43.2241 27.6912 42.5108H27.6959V42.4665V41.2098C27.6959 38.7444 25.702 37.8482 25.617 37.8112L25.6096 37.8081L22.5988 36.4464C21.7088 36.0439 21.1095 35.2032 21.031 34.2468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9057 32.7217L21.6034 32.6644C21.5736 32.3012 21.2701 32.0217 20.9057 32.0217V32.7217ZM21.031 34.2468L21.7287 34.1895V34.1895L21.031 34.2468ZM17.2843 32.7217V32.0217C16.9199 32.0217 16.6165 32.3012 16.5867 32.6644L17.2843 32.7217ZM17.159 34.2468L16.4614 34.1895V34.1895L17.159 34.2468ZM15.5912 36.4464L15.3028 35.8086L15.5912 36.4464ZM12.5804 37.8081L12.8517 38.4534C12.8574 38.451 12.8632 38.4485 12.8688 38.4459L12.5804 37.8081ZM12.573 37.8112L12.3017 37.1659L12.2935 37.1694L12.573 37.8112ZM10.4941 42.5108H9.79414C9.79414 42.8974 10.1075 43.2108 10.4941 43.2108V42.5108ZM10.4988 42.5108L11.1836 42.3656C11.115 42.0421 10.8295 41.8108 10.4988 41.8108V42.5108ZM27.6912 42.5108V41.8108C27.3606 41.8108 27.075 42.0421 27.0064 42.3656L27.6912 42.5108ZM27.6959 42.5108V43.2108C28.0825 43.2108 28.3959 42.8974 28.3959 42.5108H27.6959ZM25.617 37.8112L25.8965 37.1693L25.8884 37.1659L25.617 37.8112ZM25.6096 37.8081L25.3212 38.4459C25.3269 38.4485 25.3326 38.451 25.3383 38.4534L25.6096 37.8081ZM22.5988 36.4464L22.8872 35.8086L22.5988 36.4464ZM20.2081 32.779L20.3333 34.3042L21.7287 34.1895L21.6034 32.6644L20.2081 32.779ZM17.2843 33.4217H20.9057V32.0217H17.2843V33.4217ZM17.8567 34.3042L17.982 32.779L16.5867 32.6644L16.4614 34.1895L17.8567 34.3042ZM15.8797 37.0842C16.9962 36.5792 17.7569 35.5196 17.8567 34.3042L16.4614 34.1895C16.4041 34.8868 15.9663 35.5085 15.3028 35.8086L15.8797 37.0842ZM12.8688 38.4459L15.8797 37.0842L15.3028 35.8086L12.2919 37.1703L12.8688 38.4459ZM12.8443 38.4565L12.8517 38.4534L12.3091 37.1628L12.3017 37.1659L12.8443 38.4565ZM11.1941 41.2098C11.1941 40.1873 11.6008 39.5127 12.0097 39.0815C12.4303 38.6379 12.8574 38.4508 12.8524 38.453L12.2935 37.1694C12.1601 37.2275 9.79414 38.2945 9.79414 41.2098H11.1941ZM11.1941 42.4665V41.2098H9.79414V42.4665H11.1941ZM11.1941 42.5108V42.4665H9.79414V42.5108H11.1941ZM10.4988 41.8108H10.4941V43.2108H10.4988V41.8108ZM19.095 43.0953C16.7921 43.0953 14.717 42.9537 13.212 42.7283C12.4553 42.6149 11.8694 42.4842 11.478 42.3502C11.2798 42.2823 11.1633 42.2241 11.1061 42.1864C11.0269 42.1342 11.1443 42.1804 11.1836 42.3656L9.81405 42.6559C9.89112 43.0195 10.1601 43.2396 10.3354 43.3551C10.5325 43.4852 10.7734 43.5887 11.0245 43.6747C11.532 43.8484 12.213 43.9942 13.0046 44.1128C14.5964 44.3513 16.7438 44.4953 19.095 44.4953V43.0953ZM27.0064 42.3656C27.0457 42.1804 27.1631 42.1342 27.084 42.1864C27.0267 42.2241 26.9102 42.2823 26.712 42.3502C26.3207 42.4842 25.7348 42.6149 24.978 42.7283C23.473 42.9537 21.398 43.0953 19.095 43.0953V44.4953C21.4463 44.4953 23.5937 44.3513 25.1854 44.1128C25.9771 43.9942 26.6581 43.8484 27.1655 43.6747C27.4166 43.5887 27.6575 43.4852 27.8547 43.3551C28.03 43.2396 28.2989 43.0195 28.376 42.6559L27.0064 42.3656ZM27.6959 41.8108H27.6912V43.2108H27.6959V41.8108ZM26.9959 42.4665V42.5108H28.3959V42.4665H26.9959ZM26.9959 41.2098V42.4665H28.3959V41.2098H26.9959ZM25.3376 38.453C25.3326 38.4508 25.7597 38.6379 26.1804 39.0815C26.5893 39.5127 26.9959 40.1873 26.9959 41.2098H28.3959C28.3959 38.2945 26.03 37.2275 25.8965 37.1694L25.3376 38.453ZM25.3383 38.4534L25.3457 38.4565L25.8884 37.1659L25.881 37.1628L25.3383 38.4534ZM22.3103 37.0842L25.3212 38.4459L25.8981 37.1703L22.8872 35.8086L22.3103 37.0842ZM20.3333 34.3042C20.4332 35.5196 21.1938 36.5792 22.3103 37.0842L22.8872 35.8086C22.2237 35.5085 21.7859 34.8868 21.7287 34.1895L20.3333 34.3042Z",
    fill: "#106C3A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M23.1697 36.7085L19.0956 40.1047L15.0215 36.7085",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0215 27.4063V29.5335C15.0215 31.7835 16.8455 33.6076 19.0956 33.6076C21.3456 33.6076 23.1697 31.7835 23.1697 29.5335V27.2923C21.8672 26.957 20.8483 25.9154 20.5457 24.6001C19.5401 26.281 17.7018 27.4063 15.6007 27.4063H15.0215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0215 27.4063V26.7063C14.6349 26.7063 14.3215 27.0198 14.3215 27.4063H15.0215ZM23.1697 27.2923H23.8697C23.8697 26.9729 23.6535 26.694 23.3442 26.6144L23.1697 27.2923ZM20.5457 24.6001L21.2279 24.4432C21.1639 24.1647 20.9371 23.9532 20.6549 23.9087C20.3726 23.8641 20.0917 23.9956 19.945 24.2407L20.5457 24.6001ZM15.7215 29.5335V27.4063H14.3215V29.5335H15.7215ZM19.0956 32.9076C17.2321 32.9076 15.7215 31.3969 15.7215 29.5335H14.3215C14.3215 32.1701 16.4589 34.3076 19.0956 34.3076V32.9076ZM22.4697 29.5335C22.4697 31.3969 20.959 32.9076 19.0956 32.9076V34.3076C21.7322 34.3076 23.8697 32.1701 23.8697 29.5335H22.4697ZM22.4697 27.2923V29.5335H23.8697V27.2923H22.4697ZM19.8636 24.757C20.2249 26.3278 21.4401 27.5699 22.9952 27.9702L23.3442 26.6144C22.2943 26.3441 21.4717 25.503 21.2279 24.4432L19.8636 24.757ZM15.6007 28.1063C17.9581 28.1063 20.0197 26.8429 21.1464 24.9595L19.945 24.2407C19.0606 25.7191 17.4456 26.7063 15.6007 26.7063V28.1063ZM15.0215 28.1063H15.6007V26.7063H15.0215V28.1063Z",
    fill: "#106C3A"
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 12",
    d: "M34.9199 20.2241H53.9999",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 13",
    d: "M34.9199 23.976H47.2382",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 19",
    d: "M34.9199 31.4799H57.9498",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 14",
    d: "M34.9199 27.728H47.2382",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 16",
    d: "M50.9883 27.728H60.8581",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 20",
    d: "M34.9199 35.2319H53.646",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 22",
    d: "M45.364 47.56H61.9285",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 21",
    d: "M34.9199 38.9838H57.4142",
    stroke: "#106C3A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 23",
    d: "M7.07031 47.8281H10.1565",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 24",
    d: "M7.07031 50.5082H10.1565",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 25",
    d: "M11.75 48.0961H16.9785",
    stroke: "#106C3A",
    strokeWidth: 1.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    d: "M66.5195 51.544C66.5195 51.544 69.1035 41.5387 69.1035 44.8738C69.1035 48.2089 69.1035 50.4321 69.1035 50.4321C69.1035 50.4321 70.1597 49.5232 71.2458 47.792C72.3319 46.0609 72.6407 48.4752 72.6407 48.4752C72.6407 48.4752 74.8313 46.0609 75.5671 46.0609C76.3029 46.0609 79.2795 46.0609 79.2795 46.0609",
    stroke: "#106C3A",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdFront);
export default __webpack_public_path__ + "static/media/id-front.8b5deeb7ce2922c971d626363fb3bfcc.svg";
export { ForwardRef as ReactComponent };